import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import NotFound from "./Pages/NotFound";
import { useEffect } from "react";
import "./Assets/Styles/style_pos"
import "./Assets/i18n/i18n"
import Customer from "./Pages/cus/cus";
import CustomerAccountInfomation from "./Pages/cus/cus-account-info";
import CustomerPolicy from "./Pages/cus/cus-policy";
import CustomerPolicyInfo from "./Pages/cus/cus-policy-info";
import PaymentRequest from "./Pages/payment/payment-request";
import ClaimRequest from "./Pages/claim/claim-request";
import PosRequest from "./Pages/pos/pos-request";
import CustomerChangePassword from "./Pages/cus/cus-change-password";
// import Payment from "./Pages/payment/payment";
// import BuildMaintaince from "./Pages/build_maintaince";

function App() {
  useEffect(() => {
    document.body.classList.add("skin-blue", "sidebar-mini", "bg-phl");
    document.body.style.height = "100%";
    document.body.style.minHeight = "100%";
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path={"/"} element={<Customer />} />
        <Route exact path={"/khach-hang"} element={<CustomerAccountInfomation />} />
        <Route exact path={"/danh-sach-hop-dong"} element={<CustomerPolicy />} />
        <Route exact path={"/thanh-toan-truc-tuyen"} element={<PaymentRequest />} />
        <Route exact path={"/gui-yeu-cau"} element={<PosRequest />} />
        <Route exact path="/giai-quyet-quyen-loi" element={<ClaimRequest />} />
        <Route exact path={"/hop-dong-bao-hiem/:poNumber"} element={<CustomerPolicyInfo />} />
        <Route exact path={"/doi-mk"} element={<CustomerChangePassword />} />
        <Route exact path="/*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;